import React from 'react'
import Page from '../../components/products-page'

export default () => <Page designer={'Simon G.'} />
